var _excluded = ["logo", "title", "text", "label", "variant", "button"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import LabelAtm from "../../atoms/LabelAtm";
import TextAtm from "../../atoms/TextAtm";
import AlignContentOrg from "../../organisms/AlignContentOrg";
import PushOrg from "../../organisms/PushOrg";
import Picture from "../../quarks/Picture";
export var defaultProps = {
  variant: "default"
};
var Wrapper = styled.div.withConfig({
  componentId: "sc-1htsxcq-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["display:flex;flex-direction:column;align-items:center;justify-content:space-between;padding:", " ", ";border:", " solid ", ";border-radius:", ";"], space(5), space(4.5), unit(1), getBorderColor(theme, $onColor, "low"), getBorderRadius(theme, "large"));
});
function ProductBoxMol(_ref2) {
  var logo = _ref2.logo,
    title = _ref2.title,
    text = _ref2.text,
    label = _ref2.label,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? defaultProps.variant : _ref2$variant,
    button = _ref2.button,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $onColor: onColor
  }, restProps), /*#__PURE__*/React.createElement(AlignContentOrg, {
    horizontalAlign: "center"
  }, /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 4
  }, /*#__PURE__*/React.createElement(Picture, {
    srcData: logo,
    alt: logo.alt
  })), title, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "xsmall1"
  }, text)), label ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 1.5
  }, /*#__PURE__*/React.createElement(LabelAtm, {
    variant: variant,
    size: "small"
  }, label)) : null, button ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 2
  }, button) : null);
}
export default ProductBoxMol;